// extracted by mini-css-extract-plugin
module.exports = {"container":"j5","image":"j6","content":"j7","title":"j8","text":"j9","readMore":"ka","button":"kb"};